import React, { Suspense, lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const PolicyTerms = lazy(
  () =>
    import('@pages/dashboard/PolicyInfoAndDashboard/components/PolicyTerms'),
);
const StatusReportList = lazy(
  () =>
    import(
      '@pages/dashboard/PolicyInfoAndDashboard/components/StatusReport/StatusReportList'
    ),
);

export const PolicyInfoAndDashboardRoutes: RouteObject = {
  handle: {
    label: 'Plan Info & Dashboard',
    skipBreadCrumb: true,
  },
  children: [
    {
      path: '/dashboard/policy-terms',
      handle: {
        label: 'Plan Terms',
      },
      element: (
        <Suspense>
          <PolicyTerms />
        </Suspense>
      ),
    },
    {
      path: '/dashboard/status-report',
      handle: {
        label: 'Status Report & Map',
      },
      element: (
        <Suspense>
          <StatusReportList />
        </Suspense>
      ),
    },
  ],
};
